// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.minFooterCss_m12sljtz{font-size:14px;background-color:var(--gray00);border-top:10px solid var(--gray02);}
.mobileLegalCss_m15cfy82{text-align:center;}
.legalBandCss_lx45770{min-height:80px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/MinFooter/Footer.css"],"names":[],"mappings":"AAAA,uBAAuB,cAAc,CAAC,8BAA8B,CAAC,mCAAmC,CAAC;AACzG,yBAAyB,iBAAiB,CAAC;AAC3C,sBAAsB,eAAe,CAAC","sourcesContent":[".minFooterCss_m12sljtz{font-size:14px;background-color:var(--gray00);border-top:10px solid var(--gray02);}\n.mobileLegalCss_m15cfy82{text-align:center;}\n.legalBandCss_lx45770{min-height:80px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
